import React from "react";
import dollarIcon from "../../../assets/img/dollar.svg";
import rielIcon from "../../../assets/img/riel.svg";
import goldIcon from "../../../assets/img/gold.svg";
import { numberFormatter } from "../../../util/formatter";
import "./styles.css";

export default function CurrencyCard({ currency, title, balance, ...rest }) {
  return (
    <div
      className={`currency-card ${
        currency === "riel"
          ? "red"
          : currency === "gold"
          ? "gold-card"
          : "orange"
      }`}
      {...rest}>
      <div className="title">
        <div className="currency-panel">
          <img
            className="icon"
            src={
              currency === "riel"
                ? rielIcon
                : currency === "gold"
                ? goldIcon
                : dollarIcon
            }
            alt=""
          />
          <span>{title}</span>
        </div>
      </div>
      <div className="currency">
        <span>{numberFormatter(balance, currency === "riel" ? 0 : 2)}</span>
      </div>
    </div>
  );
}
